import { render } from "./MainProductsAccordingToModuleEntered.vue?vue&type=template&id=5d6a6a76&scoped=true"
import script from "./MainProductsAccordingToModuleEntered.vue?vue&type=script&lang=js"
export * from "./MainProductsAccordingToModuleEntered.vue?vue&type=script&lang=js"

import "./MainProductsAccordingToModuleEntered.vue?vue&type=style&index=0&id=5d6a6a76&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\front-api\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d6a6a76"]])

export default __exports__